import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';
import {initFiltersList, initSortingsList} from 'core/hooks/grid2.0';
import {mapFilters, mapSortings} from 'utils/grid-mappers';

import {
    data$,
    fetchDataFx,
    fetchTotalCountFx,
    filters$,
    filtersChanged,
    filtersReset,
    filtersSubmit,
    Gate,
    listStateChanged,
    pageIncremented,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    sortings$,
    sortingsChanged,
    sortingsReset,
    totalCount$,
    stateReset,
} from './index';

data$
    .on(fetchDataFx.done, (state, {result}) => state.concat(result))
    .reset(sortingsChanged, filtersSubmit, Gate.close);
totalCount$.on(fetchTotalCountFx.done, (_, {result}) => result).reset(Gate.close);
pageNumber$.reset(filtersSubmit, filtersReset, sortingsChanged, sortingsReset, stateReset);
pageSize$.reset(stateReset);

initFiltersList(filters$, filtersChanged, filtersReset, stateReset);
initSortingsList(sortings$, sortingsChanged, sortingsReset, stateReset);

sample({
    clock: pageIncremented,
    source: pageNumber$.map((state) => state + 1),
    target: pageNumberChanged,
});

sample({
    clock: merge([Gate.open, listStateChanged]),
    source: combine({
        sortings: sortings$,
        filters: filters$,
        pageNumber: pageNumber$,
        pageSize: pageSize$,
    }),
    fn: ({filters, sortings, pageNumber, pageSize}) => ({
        paging: {
            pageSize,
            pageNumber,
        },
        filters: mapFilters(filters),
        sortings: mapSortings(sortings),
    }),
    target: fetchDataFx,
});

sample({
    clock: merge([Gate.open, filtersSubmit, filtersReset]),
    source: combine({
        filters: filters$,
    }),
    fn: ({filters}) => ({
        filters: mapFilters(filters),
    }),
    target: fetchTotalCountFx,
});

merge([fetchDataFx.fail, fetchTotalCountFx.fail]).watch(({error}) =>
    showRestError(error as RestError),
);
